"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbMultiselect = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _sbMultiselectOption = require("./sb-multiselect-option");

var _sbMultiselectGroup = require("./sb-multiselect-group");

var _sbSelectOption = require("../sb-select-option");

var _constants = require("../sb-select-option/constants");

var _constants2 = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SbMultiselect = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbMultiselect, _PureComponent);

  var _super = _createSuper(SbMultiselect);

  function SbMultiselect(props) {
    var _this;

    _classCallCheck(this, SbMultiselect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function () {
      var isFocused = _this.state.isFocused;
      var onFocus = _this.props.onFocus;

      if (!isFocused) {
        _this.setState({
          isFocused: true
        }, onFocus());
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      var isFocused = _this.state.isFocused;
      var onBlur = _this.props.onBlur;

      if (isFocused) {
        _this.setState({
          isFocused: false
        }, onBlur());
      }
    });

    _this.id = (0, _v.default)();
    _this.state = {
      isFocused: false
    };
    return _this;
  }

  _createClass(SbMultiselect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          mode = _this$props.mode,
          id = _this$props.id,
          className = _this$props.className,
          style = _this$props.style,
          rest = _objectWithoutProperties(_this$props, ["children", "mode", "id", "className", "style"]);

      return /*#__PURE__*/_react.default.createElement(_sbSelectOption.SbSelectGeneral, _extends({}, rest, {
        componentType: _constants.COMPONENT_TYPE.MULTISELECT,
        menuPositionClass: _constants2.menuPositions.BOTTOM_RIGHT,
        mode: mode !== null && mode !== void 0 ? mode : _constants.MODE.CHECKBOX,
        id: id !== null && id !== void 0 ? id : this.id,
        className: (0, _classnames.default)('sb-multiselect', className),
        style: style !== null && style !== void 0 ? style : {},
        onFocus: this.handleOnFocus,
        onBlur: this.handleOnBlur
      }), children);
    }
  }]);

  return SbMultiselect;
}(_react.PureComponent);

exports.SbMultiselect = SbMultiselect;

_defineProperty(SbMultiselect, "propTypes", {
  onChange: _propTypes.default.func,
  liveSearch: _propTypes.default.bool,
  className: _propTypes.default.string,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
});

_defineProperty(SbMultiselect, "defaultProps", {
  onChange: _constants.NOOP,
  liveSearch: true,
  className: null,
  onFocus: _constants.NOOP,
  onBlur: _constants.NOOP
});

_defineProperty(SbMultiselect, "Option", _sbMultiselectOption.SbMultiselectOption);

_defineProperty(SbMultiselect, "Group", _sbMultiselectGroup.SbMultiselectGroup);
//# sourceMappingURL=sb-multiselect.js.map